import { Fragment } from 'react';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';

import { BotaoAcaoLinha } from '../../components/BotaoAcaoLinha';
import { BotaoAdicionar } from '../../components/RelatorioCivelComponents';
import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';

export default function Step16SustentacaoOral(props: RelatorioCivelStepProps) {
  const {
    podeEditar,
    novoNumeroProcessoSustentacao,
    setNovoNumeroProcessoSustentacao,
    novaParteSustentacao,
    setNovaParteSustentacao,
    apenasNumeros,
    adicionarSustentacaoOral,
    quantidadeLinhas,
    setQuantidadeLinhas,
    adicionarMultiplasLinhasSustentacaoOral,
    formData,
    editandoSustentacaoOral,
    valorEdicaoNumeroProcessoSustentacao,
    setValorEdicaoNumeroProcessoSustentacao,
    valorEdicaoParteSustentacao,
    setValorEdicaoParteSustentacao,
    salvarEdicaoSustentacaoOral,
    cancelarEdicaoSustentacaoOral,
    iniciarEdicaoSustentacaoOral,
    removerSustentacaoOral,
  } = props;

  return (
    <Fragment>
      {podeEditar && (
        <Row className="mb-3">
          <Col md={5}>
            <Form.Group>
              <Form.Label className="fw-bold">N.º do Processo</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ex: 000000.000.000"
                value={novoNumeroProcessoSustentacao}
                onChange={(e) => setNovoNumeroProcessoSustentacao(apenasNumeros(e.target.value))}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                    e.preventDefault();
                  }
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    adicionarSustentacaoOral();
                  }
                }}
              />
            </Form.Group>
          </Col>
          <Col md={5}>
            <Form.Group>
              <Form.Label className="fw-bold">Parte</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nome da parte"
                value={novaParteSustentacao}
                onChange={(e) => setNovaParteSustentacao(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    adicionarSustentacaoOral();
                  }
                }}
              />
            </Form.Group>
          </Col>
          <Col md={2} className="d-flex align-items-end">
            <BotaoAdicionar className="w-100" onClick={adicionarSustentacaoOral} />
          </Col>
        </Row>
      )}

      {podeEditar && (
        <Row className="mb-3">
          <Col md={6}>
            <div className="d-flex align-items-center gap-2">
              <span className="text-muted">Adicionar</span>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() =>
                  setQuantidadeLinhas((prev) => ({
                    ...prev,
                    sustentacaoOral: Math.max(1, prev.sustentacaoOral - 1),
                  }))
                }
                style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
              >
                <i className="bi bi-dash">-</i>
              </Button>
              <Form.Control
                type="number"
                min="1"
                max="50"
                value={quantidadeLinhas.sustentacaoOral}
                onChange={(e) =>
                  setQuantidadeLinhas((prev) => ({
                    ...prev,
                    sustentacaoOral: Math.max(1, parseInt(e.target.value) || 1),
                  }))
                }
                style={{ width: '60px', textAlign: 'center', borderRadius: '8px' }}
                size="sm"
              />
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() =>
                  setQuantidadeLinhas((prev) => ({
                    ...prev,
                    sustentacaoOral: Math.min(50, prev.sustentacaoOral + 1),
                  }))
                }
                style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
              >
                <i className="bi bi-plus">+</i>
              </Button>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={adicionarMultiplasLinhasSustentacaoOral}
                style={{ borderRadius: '8px' }}
              >
                <i className="bi bi-plus-lg me-1"></i>
                Adicionar {quantidadeLinhas.sustentacaoOral} linha
                {quantidadeLinhas.sustentacaoOral > 1 ? 's' : ''}
              </Button>
            </div>
          </Col>
          <Col md={6} className="d-flex align-items-center justify-content-end">
            <h5 className="mb-0 text-primary">
              <small className="text-muted">Total de Itens:</small> {formData.sustentacaoOral.itens.length}
            </h5>
          </Col>
        </Row>
      )}

      <Table bordered hover>
        <thead className="table-light">
          <tr>
            <th style={{ width: '5%' }}>#</th>
            <th style={{ width: '35%' }}>N.º do Processo</th>
            <th style={{ width: '40%' }}>Parte</th>
            {podeEditar && <th style={{ width: '20%' }}>Ações</th>}
          </tr>
        </thead>
        <tbody>
          {formData.sustentacaoOral.itens.length === 0 ? (
            <tr>
              <td colSpan={podeEditar ? 4 : 3} className="text-center text-muted">
                Nenhum item adicionado ainda
              </td>
            </tr>
          ) : (
            formData.sustentacaoOral.itens.map((item, index) => {
              const estaEditando = editandoSustentacaoOral === item.id;

              return (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>
                    {estaEditando ? (
                      <Form.Control
                        type="text"
                        size="sm"
                        placeholder="Ex: 000000.000.000"
                        value={valorEdicaoNumeroProcessoSustentacao}
                        onChange={(e) => setValorEdicaoNumeroProcessoSustentacao(apenasNumeros(e.target.value))}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                            e.preventDefault();
                          }
                        }}
                        style={{ borderRadius: '8px' }}
                      />
                    ) : (
                      item.numeroProcesso
                    )}
                  </td>
                  <td>
                    {estaEditando ? (
                      <Form.Control
                        type="text"
                        size="sm"
                        placeholder="Nome da parte"
                        value={valorEdicaoParteSustentacao}
                        onChange={(e) => setValorEdicaoParteSustentacao(e.target.value)}
                        style={{ borderRadius: '8px' }}
                      />
                    ) : (
                      item.parte
                    )}
                  </td>
                  {podeEditar && (
                    <td>
                      {estaEditando ? (
                        <div className="d-flex align-items-center justify-content-center flex-nowrap gap-1">
                          <BotaoAcaoLinha tipo="salvar" onClick={() => salvarEdicaoSustentacaoOral(item.id)} />
                          <BotaoAcaoLinha tipo="cancelar" onClick={cancelarEdicaoSustentacaoOral} />
                        </div>
                      ) : (
                        <div className="d-flex align-items-center justify-content-center flex-nowrap gap-1">
                          <BotaoAcaoLinha tipo="editar" onClick={() => iniciarEdicaoSustentacaoOral(item)} />
                          <BotaoAcaoLinha tipo="excluir" onClick={() => removerSustentacaoOral(item.id)} />
                        </div>
                      )}
                    </td>
                  )}
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
    </Fragment>
  );
}
